import dynamic from 'next/dynamic';
import styled from 'styled-components';

const Lottie = dynamic(() => import('lottie-react'), { ssr: false });

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: 20px;
  h3 {
    font-size: 24px;
  }
`;

export const GoatPen = styled.div`
  position: relative;
  height: 340px;
  overflow: hidden;
  display: flex;
  justify-content: center;
`;

export const AnimationContainer = styled(Lottie)`
  position: absolute;
  height: 280px;
  width: 280px;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  pointer-events: none;
`;

export const GoatFood = styled.div`
  position: relative;
  z-index: 1;
  color: #008080;
  font-size: 300px;
  line-height: 280px;
  font-weight: 600;
`;
